import fp from 'lodash/fp';

export default fp.map(({ criteria, value, ...props }) => {
  const formattedValue = criteria === 0 ? String(value) : `${value}%`;
  return { criteria, formattedValue, ...props };
});



// WEBPACK FOOTER //
// ../pos-master/packages/pos-helper/src/formatDiscount.js